import { API_URL } from "../config/backend";
import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";

const API = API_URL;

const CATEGORIES = {
  news:    { label: "Новости",       color: "#ff3cac", bg: "#3d0028" },
  game:    { label: "Новая игра",    color: "#3dffa0", bg: "#003d28" },
  tips:    { label: "Советы",        color: "#ffe600", bg: "#3d3700" },
  party:   { label: "Вечеринка",     color: "#ff8c00", bg: "#3d2000" },
  update:  { label: "Обновление",    color: "#00f5ff", bg: "#003d45" },
  blog:    { label: "Блог",          color: "#9b5de5", bg: "#1e0a3d" },
};

function getCat(id) {
  return CATEGORIES[id] || CATEGORIES.news;
}

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("ru-RU", { day: "numeric", month: "long", year: "numeric" });
}

function timeAgo(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return "Сегодня";
  if (days === 1) return "Вчера";
  if (days < 7) return `${days} дня назад`;
  if (days < 30) return `${Math.floor(days / 7)} нед. назад`;
  return formatDate(iso);
}

// ── Карточка в списке ────────────────────────────────────────────────────────
function NewsCard({ item, onClick, featured = false }) {
  const [hovered, setHovered] = useState(false);
  const cat = getCat(item.category);

  if (featured) {
    return (
      <div
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          cursor: "pointer",
          background: "#0d0820",
          border: `2.5px solid ${hovered ? cat.color : "rgba(255,255,255,0.08)"}`,
          borderRadius: "1.5rem",
          padding: "2rem 2.25rem",
          transition: "border-color 0.2s, transform 0.2s, box-shadow 0.2s",
          transform: hovered ? "translateY(-4px)" : "none",
          boxShadow: hovered ? `0 16px 60px ${cat.color}22` : "0 4px 24px rgba(0,0,0,0.4)",
          display: "flex", gap: "2rem", alignItems: "center",
          position: "relative", overflow: "hidden",
        }}
      >
        {/* Фоновое свечение */}
        <div style={{
          position: "absolute", inset: 0, pointerEvents: "none",
          background: `radial-gradient(ellipse at 20% 50%, ${cat.color}12 0%, transparent 60%)`,
          transition: "opacity 0.3s", opacity: hovered ? 1 : 0.5,
        }} />

        {/* Большая эмодзи-обложка */}
        <div style={{
          flexShrink: 0, width: 110, height: 110, borderRadius: "1.25rem",
          background: cat.bg, border: `2px solid ${cat.color}44`,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "3.5rem", boxShadow: `0 0 30px ${cat.color}33`,
          transition: "transform 0.2s", transform: hovered ? "scale(1.05)" : "scale(1)",
        }}>
          {item.cover_emoji || item.emoji}
        </div>

        <div style={{ flex: 1, minWidth: 0, position: "relative" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <span style={{
              background: cat.bg, border: `1.5px solid ${cat.color}55`,
              borderRadius: "0.5rem", padding: "2px 10px",
              fontFamily: "'Fredoka One',sans-serif", fontSize: "0.75rem",
              color: cat.color, letterSpacing: "0.05em",
            }}>
              {cat.label}
            </span>
            <span style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.75rem", color: "#555" }}>
              {timeAgo(item.created_at)}
            </span>
            {item.read_time && (
              <span style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.75rem", color: "#444" }}>
                · {item.read_time} мин
              </span>
            )}
          </div>
          <div style={{
            fontFamily: "'Fredoka One',sans-serif",
            fontSize: "1.35rem", color: "#fff",
            lineHeight: 1.3, marginBottom: 8,
            textShadow: "1px 1px 0 #000",
          }}>
            {item.emoji} {item.title}
          </div>
          {item.text && (
            <div style={{
              fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem",
              color: "#888", lineHeight: 1.6,
              display: "-webkit-box", WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical", overflow: "hidden",
            }}>
              {item.text}
            </div>
          )}
          <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{
              fontFamily: "'Fredoka One',sans-serif", fontSize: "0.8rem",
              color: cat.color, transition: "gap 0.2s",
            }}>
              Читать {hovered ? "→" : "›"}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: "pointer",
        background: "#0d0820",
        border: `2px solid ${hovered ? cat.color + "88" : "rgba(255,255,255,0.06)"}`,
        borderRadius: "1.25rem",
        padding: "1.25rem",
        transition: "border-color 0.2s, transform 0.2s, box-shadow 0.2s",
        transform: hovered ? "translateY(-3px)" : "none",
        boxShadow: hovered ? `0 10px 40px ${cat.color}18` : "none",
        display: "flex", flexDirection: "column", gap: 8,
        position: "relative", overflow: "hidden",
      }}
    >
      <div style={{
        position: "absolute", inset: 0, pointerEvents: "none",
        background: `radial-gradient(ellipse at top left, ${cat.color}0a 0%, transparent 60%)`,
      }} />

      {/* Шапка карточки */}
      <div style={{
        width: "100%", borderRadius: "0.85rem",
        background: cat.bg, border: `1.5px solid ${cat.color}33`,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "2.5rem", padding: "1rem 0",
        transition: "transform 0.2s", transform: hovered ? "scale(1.02)" : "scale(1)",
      }}>
        {item.cover_emoji || item.emoji}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}>
        <span style={{
          background: cat.bg, border: `1px solid ${cat.color}44`,
          borderRadius: "0.4rem", padding: "1px 8px",
          fontFamily: "'Fredoka One',sans-serif", fontSize: "0.7rem",
          color: cat.color,
        }}>
          {cat.label}
        </span>
        <span style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.7rem", color: "#444" }}>
          {timeAgo(item.created_at)}
        </span>
      </div>

      <div style={{
        fontFamily: "'Fredoka One',sans-serif",
        fontSize: "1.05rem", color: "#fff",
        lineHeight: 1.3, position: "relative",
      }}>
        {item.emoji} {item.title}
      </div>

      {item.text && (
        <div style={{
          fontFamily: "'Nunito',sans-serif", fontSize: "0.8rem",
          color: "#666", lineHeight: 1.5,
          display: "-webkit-box", WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical", overflow: "hidden",
          position: "relative",
        }}>
          {item.text}
        </div>
      )}

      <div style={{
        fontFamily: "'Fredoka One',sans-serif", fontSize: "0.75rem",
        color: cat.color, marginTop: 4, position: "relative",
      }}>
        {hovered ? "Читать →" : "Читать ›"}
      </div>
    </div>
  );
}

// ── Полная статья ────────────────────────────────────────────────────────────
function ArticleView({ item, onBack }) {
  const cat = getCat(item.category);

  // Разбиваем текст на параграфы по двойному переносу строки
  const paragraphs = (item.text || "").split(/\n\n+/).filter(Boolean);

  return (
    <div className="animate-slide-up" style={{ maxWidth: 720, margin: "0 auto", padding: "0 1rem 3rem" }}>
      {/* Назад */}
      <button onClick={onBack} style={{
        background: "none", border: "none", cursor: "pointer",
        fontFamily: "'Fredoka One',sans-serif", fontSize: "0.9rem",
        color: "#555", display: "flex", alignItems: "center", gap: 6,
        marginBottom: "1.5rem", padding: 0,
        transition: "color 0.15s",
      }}
        onMouseEnter={e => e.currentTarget.style.color = cat.color}
        onMouseLeave={e => e.currentTarget.style.color = "#555"}
      >
        ← Все новости
      </button>

      {/* Обложка */}
      <div style={{
        width: "100%", borderRadius: "1.5rem",
        background: cat.bg, border: `2.5px solid ${cat.color}44`,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "6rem", padding: "2.5rem 0",
        boxShadow: `0 0 60px ${cat.color}22`,
        marginBottom: "2rem",
        position: "relative", overflow: "hidden",
      }}>
        <div style={{
          position: "absolute", inset: 0,
          background: `radial-gradient(ellipse at center, ${cat.color}18 0%, transparent 70%)`,
        }} />
        <span style={{ position: "relative", filter: "drop-shadow(0 0 20px rgba(255,255,255,0.3))" }}>
          {item.cover_emoji || item.emoji}
        </span>
      </div>

      {/* Мета */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: "1rem", flexWrap: "wrap" }}>
        <span style={{
          background: cat.bg, border: `1.5px solid ${cat.color}55`,
          borderRadius: "0.5rem", padding: "3px 12px",
          fontFamily: "'Fredoka One',sans-serif", fontSize: "0.8rem", color: cat.color,
        }}>
          {cat.label}
        </span>
        <span style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.8rem", color: "#555" }}>
          {formatDate(item.created_at)}
        </span>
        {item.read_time && (
          <span style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.8rem", color: "#444" }}>
            · {item.read_time} мин чтения
          </span>
        )}
      </div>

      {/* Заголовок */}
      <h1 style={{
        fontFamily: "'Fredoka One',sans-serif",
        fontSize: "clamp(1.6rem, 4vw, 2.5rem)",
        color: "#fff", lineHeight: 1.2,
        textShadow: "2px 2px 0 #000",
        marginBottom: "1.5rem",
      }}>
        {item.emoji} {item.title}
      </h1>

      {/* Тело статьи */}
      {paragraphs.length > 0 && (
        <div style={{
          background: "#0d0820",
          border: `2px solid rgba(255,255,255,0.06)`,
          borderRadius: "1.25rem",
          padding: "1.75rem 2rem",
        }}>
          {paragraphs.map((p, i) => {
            // Строки начинающиеся с ## — подзаголовки
            if (p.startsWith("## ")) {
              return (
                <div key={i} style={{
                  fontFamily: "'Fredoka One',sans-serif",
                  fontSize: "1.2rem", color: cat.color,
                  marginBottom: "0.75rem",
                  marginTop: i > 0 ? "1.5rem" : 0,
                }}>
                  {p.slice(3)}
                </div>
              );
            }
            // Строки начинающиеся с - — список
            if (p.split("\n").every(l => l.startsWith("- "))) {
              return (
                <ul key={i} style={{ padding: "0 0 0 1rem", margin: "0 0 1rem" }}>
                  {p.split("\n").map((l, j) => (
                    <li key={j} style={{
                      fontFamily: "'Nunito',sans-serif", fontSize: "1rem",
                      color: "#ccc", lineHeight: 1.7, marginBottom: 4,
                      listStyleType: "none", paddingLeft: 4,
                    }}>
                      <span style={{ color: cat.color, marginRight: 8 }}>›</span>
                      {l.slice(2)}
                    </li>
                  ))}
                </ul>
              );
            }
            return (
              <p key={i} style={{
                fontFamily: "'Nunito',sans-serif",
                fontSize: "1rem", color: "#bbb",
                lineHeight: 1.8, marginBottom: "1rem",
              }}>
                {p}
              </p>
            );
          })}
        </div>
      )}

      {/* Теги */}
      {item.tags && item.tags.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: "1.5rem" }}>
          {item.tags.map((tag, i) => (
            <span key={i} style={{
              background: "#ffffff08", border: "1px solid #ffffff15",
              borderRadius: "0.5rem", padding: "3px 10px",
              fontFamily: "'Nunito',sans-serif", fontSize: "0.75rem", color: "#666",
            }}>
              #{tag}
            </span>
          ))}
        </div>
      )}

      {/* CTA */}
      <div style={{
        marginTop: "2.5rem",
        background: `linear-gradient(135deg, ${cat.bg} 0%, #0d0820 100%)`,
        border: `2px solid ${cat.color}44`,
        borderRadius: "1.25rem",
        padding: "1.5rem",
        textAlign: "center",
      }}>
        <div style={{
          fontFamily: "'Fredoka One',sans-serif",
          fontSize: "1.2rem", color: "#fff", marginBottom: 8,
        }}>
          🎮 Попробуй прямо сейчас
        </div>
        <div style={{
          fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem", color: "#888", marginBottom: "1rem",
        }}>
          32 игры · без регистрации · телефон — пульт
        </div>
        <Link to="/games" style={{
          display: "inline-block",
          background: cat.color, color: "#000",
          fontFamily: "'Fredoka One',sans-serif", fontSize: "1rem",
          padding: "0.65rem 2rem", borderRadius: "0.85rem",
          border: "3px solid #000", boxShadow: "4px 4px 0 #000",
          textDecoration: "none",
          transition: "transform 0.15s, box-shadow 0.15s",
        }}
          onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "4px 6px 0 #000"; }}
          onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "4px 4px 0 #000"; }}
        >
          Начать играть →
        </Link>
      </div>
    </div>
  );
}

// ── Фильтр по категориям ─────────────────────────────────────────────────────
function CategoryFilter({ active, onChange }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: "2rem" }}>
      <button
        onClick={() => onChange(null)}
        style={{
          background: active === null ? "#ffffff15" : "none",
          border: `1.5px solid ${active === null ? "#ffffff44" : "#ffffff15"}`,
          borderRadius: "0.75rem", padding: "5px 14px",
          fontFamily: "'Fredoka One',sans-serif", fontSize: "0.85rem",
          color: active === null ? "#fff" : "#666",
          cursor: "pointer", transition: "all 0.15s",
        }}
      >
        Все
      </button>
      {Object.entries(CATEGORIES).map(([id, cat]) => (
        <button key={id} onClick={() => onChange(id)} style={{
          background: active === id ? cat.bg : "none",
          border: `1.5px solid ${active === id ? cat.color + "66" : "#ffffff10"}`,
          borderRadius: "0.75rem", padding: "5px 14px",
          fontFamily: "'Fredoka One',sans-serif", fontSize: "0.85rem",
          color: active === id ? cat.color : "#555",
          cursor: "pointer", transition: "all 0.15s",
        }}>
          {cat.label}
        </button>
      ))}
    </div>
  );
}

// ── Главная страница ─────────────────────────────────────────────────────────
export default function NewsPage() {
  const navigate = useNavigate();
  const { newsId } = useParams();
  const [news, setNews]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive]   = useState(null); // статья для просмотра
  const [catFilter, setCatFilter] = useState(null);

  useEffect(() => {
    fetch(`${API}/news?limit=100`)
      .then(r => r.json())
      .then(d => setNews(d.news || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // Если в URL передан newsId — открываем сразу
  useEffect(() => {
    if (newsId && news.length > 0) {
      const item = news.find(n => n.id === newsId);
      if (item) setActive(item);
    }
  }, [newsId, news]);

  const openArticle = (item) => {
    setActive(item);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const closeArticle = () => {
    setActive(null);
    if (newsId) navigate("/news");
  };

  const filtered = catFilter ? news.filter(n => n.category === catFilter) : news;
  const featured = filtered[0];
  const rest     = filtered.slice(1);

  return (
    <div style={{ minHeight: "100vh", position: "relative", zIndex: 1 }}>
      <Navbar />

      <div style={{ paddingTop: "5rem", maxWidth: 1100, margin: "0 auto", padding: "5rem 1.25rem 2rem" }}>

        {active ? (
          <ArticleView item={active} onBack={closeArticle} />
        ) : (
          <>
            {/* Хедер */}
            <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
              <div style={{
                fontFamily: "'Fredoka One',sans-serif",
                fontSize: "clamp(2rem, 5vw, 3.5rem)",
                color: "#fff", textShadow: "3px 3px 0 #000",
                lineHeight: 1.1, marginBottom: "0.75rem",
              }}>
                📰 Блог NeonParty
              </div>
              <div style={{
                fontFamily: "'Nunito',sans-serif", fontSize: "1rem", color: "#666", maxWidth: 500, margin: "0 auto",
              }}>
                Новые игры, советы для вечеринок и всё что происходит на платформе
              </div>
            </div>

            {loading ? (
              <div style={{ textAlign: "center", padding: "4rem", fontFamily: "'Nunito',sans-serif", color: "#555" }}>
                Загружаем...
              </div>
            ) : news.length === 0 ? (
              <div style={{ textAlign: "center", padding: "4rem" }}>
                <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📭</div>
                <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.2rem", color: "#555" }}>
                  Пока нет публикаций
                </div>
              </div>
            ) : (
              <>
                <CategoryFilter active={catFilter} onChange={setCatFilter} />

                {/* Главная статья */}
                {featured && (
                  <div style={{ marginBottom: "1.5rem" }}>
                    <NewsCard item={featured} onClick={() => openArticle(featured)} featured />
                  </div>
                )}

                {/* Сетка */}
                {rest.length > 0 && (
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                    gap: "1rem",
                  }}>
                    {rest.map(item => (
                      <NewsCard key={item.id} item={item} onClick={() => openArticle(item)} />
                    ))}
                  </div>
                )}

                {filtered.length === 0 && catFilter && (
                  <div style={{ textAlign: "center", padding: "3rem", fontFamily: "'Nunito',sans-serif", color: "#555" }}>
                    Нет публикаций в этой категории
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}